import { Pipe, PipeTransform } from '@angular/core';


/**
 * @see https://de.wikipedia.org/wiki/Gallone
 */
export enum VolumeConversion {
  L_IMPGAL = 'L-IMPGAL', // UK imperial gallon
  L_USGAL = 'L-USGAL' // US liquid gallon
}

/**
 * This pipe is used to convert volumes, e.g. liter to gallons
 */
@Pipe({
  name: 'convertVolume',
  pure: true
})
export class MmuVolumePipe implements PipeTransform {

  transform(value: number, conversion: VolumeConversion): number {
    switch (conversion) {
      case VolumeConversion.L_IMPGAL:
        return value * 0.219969;
      case VolumeConversion.L_USGAL:
        return value * 0.264172;
    }
  }
}
